// extracted by mini-css-extract-plugin
var _1 = "InputFields-moduleinput__Vkd5f";
export { _1 as "input" }
